import "../css/footer.css";
import React from "react";
import { LuCopyright } from "react-icons/lu";
import { getCurrentYear } from "./helper-js/current-year";
import { useTranslation } from "react-i18next";
import AddProjectStore from "../../store/AddProjectStore";
import { footer_data } from "../dataFiles/footer.data";
import Skeleton from "@mui/material/Skeleton";
import { getContrastTextColor } from "./components/white-label/helper";

const Footer = () => {
  const { t } = useTranslation();
  const { white_lable, whitelable_loaded, appliedWhiteLable } = AddProjectStore(
    (state) => state
  );

  const style = {
    backgroundColor: white_lable.theme_color || "#f7f7f7",
    color: getContrastTextColor(white_lable.theme_color),
  };

  return (
    <>
      {whitelable_loaded ? (
        <footer
          className="footer-container"
          style={{
            backgroundColor: style.backgroundColor,
          }}
        >
          {appliedWhiteLable.show_footer_links ||
          appliedWhiteLable.show_footer_custom_links ? (
            <div
              style={{
                color: style.color,
                cursor: "default",
              }}
              className="footer-element d-flex align-items-center flex-wrap"
            >
              {appliedWhiteLable.show_footer_custom_links &&
              appliedWhiteLable.custom_links?.length > 0
                ? appliedWhiteLable.custom_links.map((elm, index) => {
                    return elm.url ? (
                      <React.Fragment key={`custom-url-${index}`}>
                        {Boolean(index) && <span className="mx-2"> {"|"}</span>}
                        <a
                          href={elm.url}
                          target="_blank"
                          style={{
                            color: style.color,
                          }}
                        >
                          <span className="footer-elem">{elm.label}</span>
                        </a>
                      </React.Fragment>
                    ) : (
                      <React.Fragment key={`custom-label-${index}`}>
                        {Boolean(index) && <span className="mx-2"> {"|"}</span>}
                        <span className="footer-elem">{elm.label}</span>
                      </React.Fragment>
                    );
                  })
                : footer_data?.map((elm, index) => {
                    return elm.url ? (
                      <React.Fragment key={`url-${index}`}>
                        {Boolean(index) && <span className="mx-2"> {"|"}</span>}
                        <a
                          href={elm.url}
                          target="_blank"
                          style={{
                            color: style.color,
                          }}
                        >
                          <span className="footer-elem">{t(elm.label)}</span>
                        </a>
                      </React.Fragment>
                    ) : index === 0 ? (
                      <span className="footer-elem" key={"copyright"}>
                        <LuCopyright className="me-1 heading-medium" />
                        {t("footer.user.copyright")} {getCurrentYear}
                      </span>
                    ) : (
                      <React.Fragment key={`label-${index}`}>
                        {Boolean(index) && <span className="mx-2"> {"|"}</span>}
                        <span className="footer-elem">{t(elm.label)}</span>
                      </React.Fragment>
                    );
                  })}
            </div>
          ) : null}
        </footer>
      ) : (
        <Skeleton
          height={70}
          animation="wave"
          variant="rectangular"
          className="footer-container"
        />
      )}
    </>
  );
};

export default Footer;
